import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function Progress(props) {

    const {t} = useTranslation()

    const progresses = () => {
        let progressItems = [];

        for (let i=0; i < props.size; i++) {
            if (i === parseInt(props.activeQuestion)) {
                progressItems.push(
                    <Paper key={i}
                        sx={{
                            height: "1rem",
                            width: "100%",
                            mr: 1,
                            backgroundColor: "secondary.main",
                        }}
                    />
                )
            } else if (i < parseInt(props.activeQuestion)) {
                progressItems.push(
                    <Paper key={i}
                        sx={{
                            height: "1rem",
                            width: "100%",
                            mr: 1,
                            backgroundColor: "primary.main",
                        }}
                    />
                )
            }else if (i > parseInt(props.activeQuestion)){
                progressItems.push(
                    <Paper key={i} 
                        sx={{
                            height: "1rem",
                            width: "100%",
                            mr: 1,
                            backgroundColor: "secondary.lightest",
                        }}
                    />
                )
            }
        }

        return progressItems;
    }

    return(
        <Paper sx={{padding: 2}}>
            <Typography>{t("quizProgress")}:</Typography>
            <Box sx={{
                display: "flex",
                paddingTop: 2
            }}>
                {progresses()}
            </Box>
        </Paper>
    )
}